const normalizeCreditCardCVC = (value, oldValue, allValues) => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  if (!allValues.number || !/^3[47]/.test(allValues.number)) {
    return onlyNums.slice(0, 3);
  } else {
    return onlyNums.slice(0, 4);
  }
};

export default normalizeCreditCardCVC;



// WEBPACK FOOTER //
// ./src/common/forms/normalizers/creditCardCVC.js